module.exports = __webpack_public_path__ + "static/media/BorrarBlanco.359eeb6a.svg";